import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
@Component({
  selector: 'itl-loading-indicator',
  template: `<ion-spinner *ngIf="showSpinner" name="crescent"></ion-spinner>`,
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf],
})
export class LoadingIndicatorComponent {
  @Input() delay = 1000;
  showSpinner = false;
  ngOnInit(): void {
    if (this.delay <= 0) {
      this.showSpinner = true;
      return;
    }
    setTimeout(() => {
      this.showSpinner = true;
    }, this.delay);
  }
}
